import { NEED_INVITE_MANNAGER } from './_constants/const';
import NeedInviteManager from './NeedInviteManager';

const MarketComment = ({ storeComment }: { storeComment: string }) => {
  if (storeComment === NEED_INVITE_MANNAGER) {
    return <NeedInviteManager />;
  }

  return <div className="z-[20] mt-0.5 text-red-400 Body5M14">{storeComment}</div>;
};

export default MarketComment;
